/* import __COLOCATED_TEMPLATE__ from './embedded-video-modal.hbs'; */
import Component from '@ember/component';

/**
 * Use this component to show an arbitrary video in a popover.
 */
export default Component.extend({
  tagName: '',

  /**
   * @inheritDoc
   */
  init() {
    this._super(...arguments);
    //bind this function to this context
    ['_onModalClose'].forEach( item => { this.set(item, this.get(item).bind(this))});
  },

  /**
   * The
   *
   * @param {Object}
   */
  model: {
    /**
     * The uri we'll use when opening the modal
     * @param {String}
     */
    embedUri: ''
  },

  /**
   * Called when this modal is closed.
   * @private
   */
  _onModalClose: function() {
    this.set('model.embedUri', '');
  }
});
